import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { GenerateRouteService } from 'src/app/common/service/generate-route.service';
import { ResponsiveService } from 'src/app/common/service/responsive.service';
import { WindowService } from 'src/app/common/service/window.service';
import { MetricsEnum } from 'src/app/home/enum/metrics-enum';

@Component({
  selector: 'app-pwa-metrics',
  templateUrl: './pwa-metrics.component.html',
  styleUrl: './pwa-metrics.component.scss'
})
export class PwaMetricsComponent implements OnInit, AfterViewInit {
  runKm: number = 0;
  detectedKm: number = 0;
  videos: number = 0;
  allMetricsEnum: typeof MetricsEnum = MetricsEnum;
  selectedMetrics: MetricsEnum = MetricsEnum.NONE;
  private intervalId: any;

  @ViewChild('pwaMapContainer') pwaMapContainer!: ElementRef;

  constructor(
    private generateRouteService: GenerateRouteService,
    private responsiveService: ResponsiveService,
    private windowService: WindowService
  ) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.updateMetricsForCountry(this.selectedMetrics);
    this.initializePointerScroll();
    setTimeout(() => {
      this.setInitialScrollPosition();
    }, 100);
  }

  /**
   * Configura la posición de scroll inicial al 50%
   */
  setInitialScrollPosition(): void {
    let ratio = 2;
    if (this.responsiveService.isPC()) {
      ratio = 0;
    } else if (this.responsiveService.isLandscape()) {
      ratio = 3.2;
    } else if (this.responsiveService.isTablet()) {
      ratio = 3;
    }

    const mapElement = this.pwaMapContainer.nativeElement;
    const scrollAmount = (mapElement.scrollWidth - mapElement.clientWidth) / ratio;
    mapElement.scrollLeft = scrollAmount;
  }

  /**
   * Selecciona uno de los paises
   * @param metrics
   */
  checkMetrics(metrics: MetricsEnum): void {
    this.selectedMetrics = metrics;
    this.updateMetricsForCountry(metrics);
  }

  /**
   * Actualiza las métricas según el país seleccionado
   * @param metrics
   */
  updateMetricsForCountry(metrics: MetricsEnum): void {
    const targetValues = this.getMetricsForCountry(metrics);
    this.runKm = this.detectedKm = this.videos = 0;

    if (this.intervalId) {
      clearInterval(this.intervalId);
    }

    this.intervalId = setInterval(() => {
      if (this.runKm === targetValues.runKm &&
        this.detectedKm === targetValues.detectedKm &&
        this.videos === targetValues.videos) {
        clearInterval(this.intervalId);
      } else {
        this.runKm = this.generateRandomNumber(this.runKm, targetValues.runKm);
        this.detectedKm = this.generateRandomNumber(this.detectedKm, targetValues.detectedKm);
        this.videos = this.generateRandomNumber(this.videos, targetValues.videos);
      }
    }, 50);
  }

  /**
   * Obtiene las métricas para cada caso
   * @param metrics
   * @returns
   */
  getMetricsForCountry(metrics: MetricsEnum): { runKm: number, detectedKm: number, videos: number } {
    switch (metrics) {
      case MetricsEnum.ECUADOR:
        return { runKm: 76022, detectedKm: 49467, videos: 32767 };
      case MetricsEnum.ARGENTINA:
        return { runKm: 64444, detectedKm: 32110, videos: 22707 };
      case MetricsEnum.SPAIN:
        return { runKm: 75481, detectedKm: 46287, videos: 31084 };
      case MetricsEnum.PORTUGAL:
        return { runKm: 85382, detectedKm: 51580, videos: 42556 };
      case MetricsEnum.NONE:
        return { runKm: 73235, detectedKm: 33180, videos: 51235 };
      default:
        return { runKm: 0, detectedKm: 0, videos: 0 };
    }
  }

  /**
   * genera un número aleatorio hasta llegar al número real
   * @param currentValue
   * @param targetValue
   * @returns
   */
  generateRandomNumber(currentValue: number, targetValue: number): number {
    const direction = Math.sign(currentValue - targetValue);
    const randomDelta = Math.floor(Math.random() * 21) - 2000;
    const newValue = currentValue + direction * randomDelta;
    return Math.min(Math.max(newValue, 0), targetValue);
  }

  /**
   * Obtiene la ruta en el idioma actual
   * @param routeKey
   * @returns
   */
  getRouterLink(routeKey: any): string {
    return this.generateRouteService.generateRoute(routeKey);
  }

  /**
   * Controla los eventos de click para scroll estilo móvil
   */
  initializePointerScroll(): void {
    if (this.windowService.isBrowser) {
      const pointerScroll = (elem: HTMLElement) => {
        let isDrag = false;

        const dragStart = () => isDrag = true;
        const dragEnd = () => isDrag = false;
        const drag = (ev: PointerEvent) => isDrag && (elem.scrollLeft -= ev.movementX);

        elem.addEventListener('pointerdown', dragStart);
        window.addEventListener('pointerup', dragEnd);
        window.addEventListener('pointermove', drag);
      };

      pointerScroll(this.pwaMapContainer.nativeElement);
    }
  }
}
